<div class="mxs-checkbox" *ngIf="!formReadonlyMode"
     [formGroup]="form"
     [hidden]="hidden"
     [matTooltip]="getValidationHint() | translate"
     [matTooltipClass]="'mxs-error-ttip'"
>
    <mat-checkbox *ngIf="!unshielded" [formControlName]="name" [name]="name">
        {{ getLabel() | translate }}
    </mat-checkbox>
    <mat-checkbox *ngIf="unshielded" [formControlName]="name" [name]="name">
        <label [innerHTML]="getLabel()"></label>
    </mat-checkbox>
    <span *mxInfo="informationKey"></span>
    <mat-error *ngFor="let error of getValidationMessages(true)">
        {{ getError(error) | translate }}
    </mat-error>
</div>

<div class="mxs-checkbox" *ngIf="formReadonlyMode"
               [ngClass]="{'hidden': hidden}">
    <mat-checkbox
            [name]="name"
            [disabled]="true"
            [checked]="form.controls[name].value"
    >
        {{getLabel() | translate}}
    </mat-checkbox>
    <span *mxInfo="informationKey"></span>
</div>
